import type { AgentApiCandidateEndpointsJobPostEndpointsRecord } from '@/types/serializers';
import JobPostEndpointCard from './JobPostEndpointCard';

type Props = {
  jobPostEndpoints: AgentApiCandidateEndpointsJobPostEndpointsRecord[];
  isLoading?: boolean;
  companyRefetch?: () => void;
};

export default function CompaniesJobPostEndpointsCard({
  jobPostEndpoints,
  isLoading,
  companyRefetch,
}: Props) {
  return (
    <div className="relative h-full">
      <div>
        {isLoading ? (
          <div className="flex h-64 items-center justify-center">
            <p className="text-gray-500">読み込み中...</p>
          </div>
        ) : jobPostEndpoints.length === 0 ? (
          <div className="flex h-64 items-center justify-center">
            <p className="text-gray-500">提案求人がありません</p>
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            {jobPostEndpoints.map((endpoint) => (
              <JobPostEndpointCard
                key={endpoint.id}
                endpoint={endpoint}
                companyRefetch={companyRefetch}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
